import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter, Link, Router, useLocation } from 'react-router-dom'
import gamefilter from "../../dataset/gamefilter.json";
import Carousel from "react-multi-carousel";
import { useTranslation } from 'react-i18next';

import './Nav2.css'
function Nav2() {
  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation

  const [isMobile, setIsMobile] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const filters = gamefilter

  const location = useLocation(); // ใช้ useLocation เพื่อดึงข้อมูล URL ปัจจุบัน
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 4
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="row nav mb-2" style={{ margin: 0 }}>
      {/* <!-- =====header======== --> */}
      <div className="col-12">
        <div className='d-flex scroll-container'>
          {/* <div className={isMobile ? "d-flex scroll-container" : "d-none"}> */}
          {filters.map((filter, index) => (
            <Link
              key={index}
              className={[
                "text-light link ",
                location.pathname === filter.path ? "active" : "",
              ].join(" ")
              }
              to={filter.path}
            >
              <img
                src={require(`../../assets/icons/${filter.icon}`)}
                alt={`${filter.category}`}
                width={15}
                className='m-1'
              />
              <p className='m-0'>   {t(filter.category)}</p>

            </Link>
          ))}
        </div>
      </div>
    </div>

  )
}

export default Nav2